import { useEffect, useState } from "react"
import clienteAxios from "../../../configAxios/configAxios";
import axios from 'axios';
import { set } from "js-cookie";


export const useDestacadosHome = (seccion) => {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [destacados, setDestacados] = useState([]);
    const [camiones, setCamiones] = useState([]);
    const [comerciales, setComerciales] = useState([]);
    const [buses, setBuses] = useState([]);

    useEffect(() => {
        if (seccion) {
            const fetchDestacados = async () => {
                try {
                    let response = await clienteAxios.get(`Modelo/home/${seccion}`)

                    if (response.status === 200) {
                        let data = response.data.data;
                        setDestacados(data)
                        if (data && data.length > 0) {
                            data.map((categoria) => categoria.idCategoria === 3 ? setCamiones(categoria.vehiculos) : categoria.idCategoria === 2 ? setComerciales(categoria.vehiculos) : categoria.idCategoria === 4 && setBuses(categoria.vehiculos))
                        }
                        setLoading(false);
                        return
                    }

                    setLoading(false);
                    setError(true);
                } catch (error) {
                    setLoading(false);
                    setError(true);
                }
            }
            fetchDestacados();
        }
    }, [seccion])

    return [camiones, comerciales, buses, destacados, error, loading];
}

export const useModulos = () => {
    const [modulos, setModulos] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchModulos = async () => {
            try {
                let response = await clienteAxios.get('BuscarSeccionActivoPorModulo/HOME');
                if (response.status === 200) {
                    let data = response.data.data;

                    setModulos(data);
                    setLoading(false);
                    return
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchModulos();
    }, [])

    return { modulos, error, loading }
}

export const useBannerSecundario = () => {
    const [banner, setBanner] = useState(undefined);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                let response = await clienteAxios.get('sliders/modulo/HOME')
                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    let banner = data.filter(banner => banner.Seccion === 'SECUNDARIO');
                    if (banner.length > 0) setBanner(banner[0]);

                    return
                }
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchBanners();
    }, [])

    return { banner, error, loading }
}

export const useGeoLocation = () => {
    const [geoLocation, setGeoLocation] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGeoLocation = async () => {
            try {
                let response = await axios.get('https://pro.ip-api.com/json/?key=HI80ioIvnmwT3jW&lang=es');
                if (response.status === 200) {
                    let data = response.data;

                    setGeoLocation(data);
                    setLoading(false);
                    return
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchGeoLocation();
    }, [])

    return { geoLocation, error, loading }
}

export const useParametro = () => {
    const [parametro, setParametro] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchParametro = async () => {
            try {
                let response = await clienteAxios.get('Parametro/activo/HOME');
                if (response.status === 200) {
                    let data = response.data;
                    setParametro(data);
                    setLoading(false);
                    return;
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchParametro();
    }, []);
    return {parametro, error, loading}
}